import { CollectionMethodConstants as Constants } from '../types'

const initialState = {
    methods: [],
    loading: false,
    error: null,
}

export function collectionMethodReducer(state = initialState, action) {
    switch (action.type) {
        case Constants.LOADING:
            return { ...state, loading: true, error: null }

        case Constants.GET:
            return {
                ...state,
                loading: false,
                error: null,
                methods: action?.payload?.data || action?.payload || [],
            }

        case Constants.FAIL:
            return { ...state, loading: false, error: action?.error }

        default:
            return state
    }
}
